// extracted by mini-css-extract-plugin
module.exports = {"typeKeysList":"styles_typeKeysList__28jXG","typeKeyItem":"styles_typeKeyItem__2-dTm"};